<template>
    <div>
        <ul class="assess-filter" >
            <li @click="yearClick" >{{yearSelected}}-{{yearSelected + 1}}<i class="iconfont icon-xia" ></i></li>
            <li @click="termClick" >{{termSelected == 1 ? '第一学期':'第二学期'}}<i class="iconfont icon-xia" ></i></li>
        </ul>
        <ul class="assess-quality-list"
            v-infinite-scroll="loadMore"
            infinite-scroll-disabled="isMoreLoading"
            :infinite-scroll-immediate-check="true"
            infinite-scroll-distance="10">
            <router-link tag="li" :to="{ name: 'Assess-student-msg-detail', query: {id: msg.id, userId: msg.userId} }" v-for="(msg,index) in msgList" :key="index">
                <div class="msg-title-wrapper" >
                    <h4>{{msg.content}}</h4>
                    <i class="iconfont icon-delete" @click.stop="deleteRecord(msg.id)" v-if="userInfo.userType != 2 || userInfo.isAdmin == 1" ></i>
                </div>
                <div class="msg-applier" >{{msg.stuName}}（{{msg.className}}）</div>
                <div class="msg-handle" v-if="userInfo.userType != 2 || userInfo.isAdmin == 1" >
                    <span>受理部门：{{msg.codeName}}</span>
                    <span>受理人员：{{msg.teaName}}</span>
                </div>
                <div class="msg-time" >
                    <span>{{msg.makeTime}}</span>
                    <span class="is-handle handled" v-if = "msg.type == 2" >已回复</span>
                    <span class="is-handle no-handle" v-else >未回复</span>
                </div>
            </router-link>
        </ul>

        <div class="loading-box" v-if="isLoading">
            <mt-spinner type="snake" class="loading-more"></mt-spinner>
            <span class="loading-more-txt">加载中...</span>
        </div>

        <div class="no-more" v-if="noMore">没有更多了~</div>

        <router-link class="assess-admin-add-btn" v-if="userInfo.userType != 2" tag="div" :to="{ name: 'Assess-student-msg-add' }" >
            <span>+</span>
        </router-link>

        <mt-popup
            v-model="popupVisible"
            position="bottom"
            class="assess-filter-type">
            <ul class="history-list list-gap" >
                <!-- 学年筛选 -->   
                <li @click="switchYear(value)" v-for="(value,key) in yearList" v-if="isShowYear" :key="key" >{{value}}-{{value + 1}}</li>
                <!-- 学期筛选 -->
                <li v-if="isShowTerm" @click="switchTerm(value)" v-for="(value,key) in termList" :key="key" >{{value == 1 ? '第一学期': '第二学期'}}</li>
            </ul>
        </mt-popup>

        <!-- 底部返回上一页 返回首页信息放这里 -->
        <bottom></bottom>
    </div>
</template>
<script>
import Bottom from '../bottom.vue'
import { getUserInfo } from '../../service/user-service.js'
import { MessageBox } from 'mint-ui';
import Vue from 'vue'
import { Spinner, InfiniteScroll, Toast } from 'mint-ui'
Vue.use(InfiniteScroll)
Vue.component(Spinner.name, Spinner)
export default {
    data() {
        return {
            timeInfo: {},
            userInfo: {},
            yearSelected: '',
            termSelected: '',
            yearList: [],
            termList: [1,2],
            popupVisible: false,
            isShowYear: false,
            isShowTerm: false,
            msgList: [],
            isLoading: false, // 加载中转菊花
            isMoreLoading: true, // 加载更多中
            noMore: false, // 是否还有更多
            pageInfo: { // 分页信息
                page: 1,
                page_size: 10,
                total: 0, // 总条数
                totalPage: 1 // 总分页数
            }
        }
    },
    components: { Bottom },
    mounted () {
        this.$nextTick( () => {
            getUserInfo().then((user) => {
                this.timeInfo = user.nowYearAndTermAndMonth;
                this.userInfo = user.user;
                this.summaryClick = {
                    year: this.timeInfo.year,
                    term: this.timeInfo.term,
                    month: this.timeInfo.month
                }
                this.yearSelected = this.summaryClick.year;
                this.termSelected = this.summaryClick.term;
                for(let i = 0; i<5; i++) {
                    this.yearList.push(this.summaryClick.year - i);
                }
                this.getMsgData();
            });
        });
    },
    methods: {
        // 学年切换
        yearClick() {
            this.isShowYear = true;
            this.popupVisible = true;
            this.isShowTerm = false;
        },
        switchYear(currentYear) {
            this.isShowYear = false;
            this.popupVisible = false;
            this.yearSelected = currentYear;
            this.getMsgData();
        },
        // 学期切换
        termClick() {
            this.isShowTerm = true;
            this.popupVisible = true;
            this.isShowYear = false;
        },
        switchTerm(currentTerm) {
            this.isShowTerm = false;
            this.popupVisible = false;
            this.termSelected = currentTerm;
            this.getMsgData();
        },
        // 获取留言列表
        getMsgData(type) {
            this.$http.get('/api/mobile/devel/comment/getLeaveWord', {
                params: {
                    schoolId: this.userInfo.schoolId,
                    schoolYear: this.yearSelected,
                    eduPeriod: this.termSelected,
                    isAdmin: this.userInfo.isAdmin,
                    page: this.pageInfo.page,
                    rows: this.pageInfo.page_size,
                }
            }).then( res => {
                if(res.data.code == 0) {
                    if(type === 'loadMore') {
                        this.msgList = this.msgList.concat(res.data.data);
                    } else {
                        this.msgList = res.data.data;
                    }
                    // 设置分页
                    this.pageInfo.total = res.data.page.totalResult;
                    this.pageInfo.totalPage = Math.ceil(this.pageInfo.total / this.pageInfo.page_size);
                } else {
                    Toast({
                        message: res.data.msg,
                        duration: 2000
                    });
                }
                this.isLoading = false;
                this.isMoreLoading = false;
            });
        },
        loadMore () { // 加载更多
            this.pageInfo.page += 1 // 增加分页
            this.isMoreLoading = true // 设置加载更多中
            this.isLoading = true // 加载中
            if (this.pageInfo.page > this.pageInfo.totalPage) { // 超过了分页
                this.noMore = true // 显示没有更多了
                this.isLoading = false // 关闭加载中
                return false
            }
            // 做个缓冲
            setTimeout(() => {
                this.getMsgData('loadMore');
            }, 100)
        },
        // 删除当前留言记录
        deleteRecord(id) {
            MessageBox.confirm('确定删除留言？').then(res => {
                this.$http.get('/api/mobile/devel/comment/deleteLeave', {
                    params: {
                        id: id
                    }
                }).then(res => {
                    if(res.data.code == 0) {
                        this.msgList = this.msgList.filter(item => {
                            return item.id != id;
                        })
                    }
                }).catch(() => {
                    console.log('取消');
                    return;
                })
            })
        },
    }
}
</script>




// WEBPACK FOOTER //
// src/components/assessment/assess-student-msg.vue